import { register } from '@shopify/theme-sections';
import Swiper from 'swiper/bundle';

register('notification-bar', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  /**
   * Callback function when section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
   */
  cleanSlide(id) {
    const target = `.notification-bar__slider--${id}`;
    new Swiper(target, {
      slidesPerView: 1,
      loop: true,
      freeMode: false,
      fadeEffect: {
        crossFade: true,
      },
      effect: 'fade',
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
    });
  },
});
